// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__Zmttt","options":"AnswerScale_options__2ErOc","selected":"AnswerScale_selected__XzpOk"};